var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21.061,
    viewBox: "0 0 25 21.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(-731.846 -98.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-trending-up",
    "data-name": "Icon material-trending-up",
    d: "M20.5,9l2.863,2.862-6.1,6.1-5-5L3,22.238,4.762,24l7.5-7.5,5,5,7.875-7.862L28,16.5V9Z",
    transform: "translate(728.846 96)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-money",
    "data-name": "Icon metro-money",
    d: "M13.906,11.062c-1.332-.346-1.76-.7-1.76-1.259,0-.64.59-1.088,1.584-1.088,1.044,0,1.432.5,1.467,1.232h1.3A2.336,2.336,0,0,0,14.61,7.712V6.427H12.85V7.694A2.29,2.29,0,0,0,10.8,9.812c0,1.355,1.124,2.03,2.758,2.423,1.47.352,1.76.865,1.76,1.417,0,.4-.285,1.047-1.584,1.047-1.209,0-1.687-.543-1.748-1.232H10.688a2.464,2.464,0,0,0,2.162,2.247v1.273h1.76V15.726c1.141-.22,2.054-.88,2.054-2.086,0-1.66-1.426-2.23-2.758-2.579Z",
    transform: "translate(731.305 92.512)",
    fill: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/profitIcon.dabb9b41.svg";
export { ForwardRef as ReactComponent };